import { Field } from 'formik'
import PropTypes from 'prop-types'
import React from 'react'
import SwapList from '../SwapList'

const propTypes = {
  /**
   * id of the field. The id passed is also bound to the field's name
   */
  id: PropTypes.string.isRequired,
  /**
   * If exists, calls it with the value for custom additional actions
   * Formik setFieldValue will always run before it
   */
  onChange: PropTypes.func,
}

/**
 * Connects the SwapList with Formik.
 */
function FormikSwapList(props) {
  const { id, onChange = null } = props ?? {}

  return (
    <Field name={id}>
      {({ field, form }) => (
        <SwapList
          {...props}
          id={id}
          onChange={(value) => {
            form.setFieldValue(id, value)
            form.setFieldTouched(id, true) // set the touched flag (important for displaying errors)
            if (onChange) {
              onChange(value)
            }
          }}
          value={field.value}
          // errors={meta.touched && meta.error ? [meta.error] : []} // error handling was not added yet
        />
      )}
    </Field>
  )
}

FormikSwapList.propTypes = propTypes

export default FormikSwapList
